import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, shareReplay } from 'rxjs';
import { Workshop } from './models/workshop.model';

/**
 * Carga los 475 talleres desde el asset "slim" (≈108 KB) de forma DIFERIDA
 * vía HttpClient — nunca se importa el JSON de 15 MB al bundle. El resultado
 * se cachea con shareReplay para que múltiples suscriptores no relancen la
 * petición.
 */
@Injectable({ providedIn: 'root' })
export class WorkshopMockService {
  private static readonly URL = 'assets/mocks/workshops.slim.json';
  private cache$?: Observable<Workshop[]>;

  constructor(private readonly http: HttpClient) {
    // do nothing
  }

  getWorkshops(): Observable<Workshop[]> {
    if (!this.cache$) {
      this.cache$ = this.http.get<Workshop[]>(WorkshopMockService.URL).pipe(
        map((list) => (Array.isArray(list) ? list.filter((w) => isFinite(w.lat) && isFinite(w.lng)) : [])),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    }
    return this.cache$;
  }
}
